<template>
  <div class="switch">
    <input
      :id="id"
      :checked="checked"
      type="checkbox"
      @change="$emit('change', $event)"
    >
    <label
      :for="id"
      class="switch-ui"
    />
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.switch {
  input {
    display: none;

    &:checked {
      + .switch-ui {
        background-color: $green;

        &::before {
          transform: translateX(15px);
        }
      }
    }
  }

  &-ui {
    @include size(40px, 24px);
    display: block;
    position: relative;
    transition: background-color .4s $ease-out-quad;
    background-color: $primary;
    border-radius: 12px;

    &::before {
      @include size(20px);
      @include position(absolute, 2px null null 3px);
      content: '';
      border-radius: 50%;
      transition: transform .3s $ease-out-quad;
      background-color: $white;
      pointer-events: none;
    }
  }
}
</style>
